/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:31 
 * @Last Modified by:   wangxiang 
 * @Last Modified time: 2019-11-11 13:42:31 
 */
export default {
  name: 't-background',
  render () {
    let style = {
      width: '100%',
      height: '100%'
    }

    if (this.imgSrc) {
      style = {
        ...style,
        'background-size': 'cover',
        'background-position': '50% 50%',
        'background-origin': 'content-box',
        'background-image': `url(${this.imgSrc})`
      }
    } else {
      style = {
        ...style,
        backgroundColor: this.backgroundColor
      }
    }

    return (
      <div style="width: 100%; height: 100%; overflow: hidden; position: absolute; z-index: 0; opacity: 1;">
        <div style={style}></div>
      </div>
    )
  },
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      // TODO 为什么 transparent 无效？
      default: '#FFCD76'
    }
  },
  editorConfig: {
    propsConfig: {
      imgSrc: {
        //type: 'image-gallery',
        type: 'a-input',
        label: '图片url',
        prop: {
          type: 'textarea'
        },
        defaultPropValue: ''
      },
      backgroundColor: {
        type: 'a-input', // lbs-color-picker
        label: '背景颜色',
        prop: {
          type: 'color'
        },
        require: true,
        defaultPropValue: '#ffffff'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/album/plugins/t-background.js